import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import './styles.css';
import ItecDialog from '../../../modules/checkListGenerator/itechChecklist/itechAddRelevancePopUp';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    heading1: {
        fontSize: '15px',
        fontWeight: 700,
        color: '#000',
    },
    bottomLine: {
        // borderBottom: '1px solid #ccc !important',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
}));

const ItechLabelB = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });
    const [itecOpen, setItecOpen] = React.useState(false);

    const handleRelevence = () => {
        //console.log('handleRele++++');
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };
    return (
        <>
            <Grid container spacing={3} className="main-container">
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Name of company</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.name}
                            placeholder="Enter Name"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">PAN of the company</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.pan}
                            placeholder="Enter PAN"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography className={classes.heading1}>Financial Asset</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">a. Bank(Including all deposits)</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Amount"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">b. Shares and securities</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Amount"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Insurance Policies</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Amount"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">d. Loans and advances given</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Amount"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Cash in hand</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Amount"
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
            </Grid>
            {itecOpen && <ItecDialog itecOpen={itecOpen} handleItecClose={handleItecClose} />}
        </>
    );
};

export default ItechLabelB;
